import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { mapSetSchema } from './schemas/map-set.schema';

export function getMapSetsId(id: number) {
  return fromFetch(
    new Request(`${fleetEnvironment.mapSetsUrl}/${id}`, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
    })
  ).pipe(selectData(mapSetSchema));
}
